module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "journey-chat-widget"
  }, [_c('button', {
    staticClass: "ai-toggle-btn",
    class: {
      open: _vm.open
    },
    attrs: {
      "title": "Journey Chat"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('svg', {
    staticClass: "icon-chat",
    attrs: {
      "width": "22",
      "height": "22",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "icon-close",
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "ai-chat",
    class: {
      open: _vm.open,
      resizing: _vm.resizing
    },
    style: ({
      width: _vm.width + 'px',
      height: _vm.height + 'px'
    })
  }, [_c('div', {
    staticClass: "ai-chat-resize",
    attrs: {
      "title": "Drag to resize"
    },
    on: {
      "mousedown": _vm.startResize
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ai-chat-head"
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "var(--accent)",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ai-chat-title"
  }, [_vm._v("Journey Chat")]), _vm._v(" "), _c('button', {
    staticClass: "ai-chat-close",
    attrs: {
      "title": "Close"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])])]), _vm._v(" "), _c('div', {
    ref: "body",
    staticClass: "ai-chat-body"
  }, [_vm._l((_vm.messages), function(m, i) {
    return _c('div', {
      key: i,
      staticClass: "ai-msg",
      class: m.role
    }, [_c('div', {
      staticClass: "ai-bubble"
    }, [(m.contextStage) ? _c('span', {
      staticClass: "ai-context-badge"
    }, [_vm._v("📍 " + _vm._s(m.contextStage))]) : _vm._e(), _vm._v(_vm._s(m.text)), (m.attachmentName) ? _c('span', {
      staticClass: "ai-attachment-badge"
    }, [_vm._v("📎 " + _vm._s(m.attachmentName))]) : _vm._e(), (m.hasJson) ? _c('span', {
      staticClass: "ai-json-badge"
    }, [_vm._v("Journey updated")]) : _vm._e()])])
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "ai-msg assistant"
  }, [_vm._m(0)]) : _vm._e()], 2), _vm._v(" "), (_vm.contextStage) ? _c('div', {
    staticClass: "ai-context-chip"
  }, [_c('span', {
    staticClass: "ai-context-icon"
  }, [_vm._v("📍")]), _vm._v(" "), _c('span', {
    staticClass: "ai-context-label"
  }, [_vm._v(_vm._s(_vm.contextStage))]), _vm._v(" "), _c('button', {
    staticClass: "ai-context-clear",
    attrs: {
      "title": "Remove context"
    },
    on: {
      "click": _vm.clearContext
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), (_vm.attachment || _vm.attaching || _vm.attachError) ? _c('div', {
    staticClass: "ai-context-chip",
    class: {
      'ai-context-chip-error': _vm.attachError
    }
  }, [_c('span', {
    staticClass: "ai-context-icon"
  }, [_vm._v("📎")]), _vm._v(" "), (_vm.attaching) ? _c('span', {
    staticClass: "ai-context-label"
  }, [_vm._v("Uploading…")]) : (_vm.attachError) ? _c('span', {
    staticClass: "ai-context-label"
  }, [_vm._v(_vm._s(_vm.attachError))]) : _c('span', {
    staticClass: "ai-context-label"
  }, [_vm._v(_vm._s(_vm.attachment.fileName))]), _vm._v(" "), _c('button', {
    staticClass: "ai-context-clear",
    attrs: {
      "title": "Remove attachment"
    },
    on: {
      "click": _vm.clearAttachment
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ai-chat-input"
  }, [_c('div', {
    staticClass: "ai-composer"
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".json,.xlsx,.xls,.pdf"
    },
    on: {
      "change": _vm.onFileSelected
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ai-attach-btn",
    attrs: {
      "title": "Attach JSON, Excel, or PDF",
      "disabled": _vm.loading || _vm.attaching
    },
    on: {
      "click": function($event) {
        return _vm.$refs.fileInput.click()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"
    }
  })])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.draft),
      expression: "draft"
    }],
    ref: "textarea",
    attrs: {
      "rows": "1",
      "placeholder": "Describe changes to this journey...",
      "disabled": _vm.loading
    },
    domProps: {
      "value": (_vm.draft)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        $event.preventDefault();
        return _vm.send.apply(null, arguments)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.draft = $event.target.value
      }, _vm.autoGrow]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ai-send-btn",
    attrs: {
      "title": "Send",
      "disabled": _vm.loading || _vm.attaching
    },
    on: {
      "click": _vm.send
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "22",
      "y1": "2",
      "x2": "11",
      "y2": "13"
    }
  }), _c('polygon', {
    attrs: {
      "points": "22 2 15 22 11 13 2 9 22 2"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ai-bubble ai-bubble-loading"
  }, [_c('span', {
    staticClass: "ai-dot"
  }), _c('span', {
    staticClass: "ai-dot"
  }), _c('span', {
    staticClass: "ai-dot"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5e97060d","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/journey-flow/JourneyChat.vue
// module id = kkpE
// module chunks = 1